import { SongUb } from "../../gql/graphql";
import { BackendConfig } from "../../Config";

export async function uploadFiles(
  fileArray: File[],
  song: SongUb,
  token: string,
) {
  // Parallele Uploads mit Promise.all für bessere Performance (HTTP2 Multiplexing)
  const uploadPromises = fileArray.map((file) =>
    uploadSource(song.bucket, song.id, file, token).then((result) => ({
      file,
      result,
    })),
  );

  const uploadResults = await Promise.all(uploadPromises);

  // Akkumuliere Ergebnisse
  return uploadResults.reduce(
    (acc, { file, result }) => ({
      successCount: acc.successCount + (result.success ? 1 : 0),
      failedFiles: result.success
        ? acc.failedFiles
        : [...acc.failedFiles, file.name],
      uploadedHashes: result.hash
        ? [...acc.uploadedHashes, result.hash]
        : acc.uploadedHashes,
    }),
    {
      successCount: 0,
      failedFiles: [] as string[],
      uploadedHashes: [] as string[],
    },
  );
}

async function uploadSource(
  bucket: string,
  id: string,
  file: File,
  token: string,
): Promise<{ success: boolean; hash?: string }> {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const url = `${BackendConfig.baseUrl}/${bucket}/songs/${id}/sources`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload fehlgeschlagen: ${response.statusText}`);
    }

    // Parse response to get the hash
    const data = await response.json();
    const hash = data.hash;

    return { success: true, hash };
  } catch (err) {
    const error = err instanceof Error ? err : new Error("Unbekannter Fehler");
    console.error("Fehler beim Hochladen der Quelldatei:", error);
    return { success: false };
  }
}
